import axios from 'axios';
import router from "@/router";
import store from "@/store";
import qs from 'qs';
import { Message } from 'element-ui';
var instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json'
    }
})

//------------------- 一、请求拦截器
instance.interceptors.request.use(function (config) {
    // console.log(config.requestBaseUrl)
    if(config.requestBaseUrl === 'notoken'){
        config.headers['X-DEVICE-TYPE'] = 5;
        config.headers['X-APP-NAME'] = 'musicwow';
    }else{
        // 注入token
        let token = localStorage.getItem('user_token');
        if(token){
            config.headers['YW-TOKEN'] = token;
        }
        config.headers['X-DEVICE-TYPE'] = 5;
        config.headers['X-APP-NAME'] = 'musicwow';
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

//----------------- 二、响应拦截器
instance.interceptors.response.use(function (response) {
    // console.log(response);
    if(response.data.error_code===18003001||response.data.error_code===18003003||response.data.error_code===18003011){
        // token失效，返回登录页
        localStorage.clear();
        store.commit("setUserInfo", {});
        Message({
          message: '登录凭证已失效，返回登录页',
          type: "warning"
        });
        setTimeout(() => {
          router.replace({name:'login'},()=>{},()=>{});
        }, 1000);
        return Promise.reject();
    }else{
        return response.data; 
    }
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});


export default function (method, url, data = null,requestBaseUrl = '') {
    method = method.toLowerCase();
    instance.defaults.requestBaseUrl = requestBaseUrl;
    if (method == 'post') {
        return instance.post(url, data)
    } else if (method == 'get') {
        return instance.get(url, {params:data})
    } else if (method == 'delete') {
        return instance.delete(url, { params: data })
    } else if (method == 'put') {
        return instance.put(url, data)
    } else {
        console.error('未知的method' + method)
        return false
    }

}